/*
 |--------------------------------------------------------------------------
 | Meer informatie module
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */
 
//no imports needed

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const
	/**
	 * The module name
	 * @type {String}
	 */
	moduleName = 'comparator',
	/**
	* Lookup table with class names
	* @type {Object}
	*/
	classNames = {
		base: `js-${ moduleName }`},
	/**
	 * Lookup table for selectors
	 * @type {Object}
	 */
	selectors = {
		base: `.js-${ moduleName }`,
		container: `.js-${ moduleName }-container`};

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP MEER INFORMATIE
 \* ========================================================================== */

class Accordion {
	constructor(heading) {
		this.heading = heading;
	}

	toggleAccordion() {
		
		if(document.querySelectorAll(this.heading) == undefined || document.querySelectorAll(this.heading).length == 0)
			return;
		
		const accordionHeading = Array.prototype.slice.call(document.querySelectorAll(this.heading));

		accordionHeading.forEach((item, key) => {
			item.addEventListener('click', () => {
				//close opened accordions
				accordionHeading.forEach(element => {
					if(element.classList.contains('active') && element !== item){
						element.classList.remove('active');
					}
				});
				//open clicked accordion
				item.classList.toggle('active');
			});
			//open first accordion by default
			if (key === 0) {
				item.classList.add('active')
			}
		});
	}
}


const accordion = new Accordion(selectors.container);

/* == END SETUP MEER INFORMATIE ===================================================== */

/* ========================================================================== *\
 EVENT HANDLING
 \* ========================================================================== */

// No event handling needed

 /* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
 INITIALIZATION
 \* ========================================================================== */

if (document.getElementsByClassName(classNames.base).length){
    accordion.toggleAccordion();
}

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
 EXPORTS
 \* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */